import { Grid, Typography, Box, styled } from '@mui/material';
import React from 'react';
import Logo from '../../../components/common/Logo';
import { imageList } from '../../../assets/images';
import WelcomeBottom from './WelcomeBottom';
import AddIcon from '@mui/icons-material/Add';

interface ImageList {
    [key: string]: string;
}

const LogoDetailContainer = styled(Grid)({
    padding: '0px 30px',
})

const GroupImageStyle = styled('img')({
    width: '80px',
    height: '80px',
})

const PlusIconStyle = styled(AddIcon)({
    fontSize: '20px',
    color: 'gray',
    marginTop:'auto',
    marginBottom:'10px'
})

const WelcomeContent = () => {
    return (
        <Grid container spacing={3} direction="column" alignItems="center">
            {/* Logo and Main Title */}
            <LogoDetailContainer mt={4}>
                    {/* <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                            <img
                                src={(imageList as ImageList)["logo"]}
                                alt=""
                                style={{ verticalAlign: "middle", borderRadius: '50%',objectFit:'cover', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
                            />
                        </Grid>
                        <Grid item>
                            <Typography variant="h3">Welcome to</Typography>
                            <Typography variant="h3" fontWeight="bold">Manage My Moves</Typography>
                        </Grid>
                    </Grid> */}
                    <img src="welcome_screen.png" alt="" style={{marginLeft:-15}} />
                {/* Welcome Message */}
                <Grid item >
                    <Typography marginY={3} variant="body1">
                        Welcome to the Manage My Moves family!
                    </Typography>
                    <Typography variant="body1">
                        We are excited to have you on board and can’t wait to help you streamline your removal operations with our cutting-edge software solution.
                    </Typography>
                </Grid>
            </LogoDetailContainer>

            {/* Feature Icons */}
            <Grid item my={4}>
                <Grid sx={{
                    '& .MuiGrid-item': {
                        padding: 0,
                        "& img": {
                            width: "100px",
                            height: "100px",
                        },
                        '& >div > p': {
                            maxWidth: "100px",
                            fontWeight: 700
                        },
                    },
                    gap:'8px'
                }} container justifyContent="center" >
                    <Grid item>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <img src="/customer-relationship-management.png" alt="Lead Integration" />
                            <Typography align="center">Lead Integration</Typography>
                        </Box>
                    </Grid>
                    <PlusIconStyle/>
                    <Grid item>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <img src="/businessman.png" alt="Customer Organisation" />
                            <Typography align="center">Customer Organisation</Typography>
                        </Box>
                    </Grid>
                    <PlusIconStyle/>
                    <Grid item>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <img src="/compliance.png" alt="Document Generation" />
                            <Typography align="center">Document Generation</Typography>
                        </Box>
                    </Grid>
                    <PlusIconStyle/>
                    <Grid item>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <img src="/customer-portel.png" alt="Customer Portal" />
                            <Typography align="center">Customer Portal</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <WelcomeBottom />
        </Grid>
    );
}

export default WelcomeContent;
